import script from "./VueTextFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueTextFilter.vue?vue&type=script&setup=true&lang=ts"

import "./VueTextFilter.vue?vue&type=style&index=0&id=48a6474c&lang=css"

const __exports__ = script;

export default __exports__